enum FundingAccountSelectVerificationTypeActionType {
    FUNDING_ACCOUNT_SELECT_VERIFICATION_TYPE = "FUNDING_ACCOUNT_SELECT_VERIFICATION_TYPE",
}

export default FundingAccountSelectVerificationTypeActionType;